import { languageDetector } from '@features/intl/languageDetector';
import { useQuery } from '@tanstack/react-query';
import { type ReactNode, useCallback, useMemo } from 'react';
import { IntlProvider as Provider } from 'react-intl';
import { DEFAULT_LOCALE } from './contants';
import { getMessages } from './service';
import type { TpLocale } from './types';
export const IntlProvider = ({
  children
}: TpIntlProviderProps) => {
  const currentLocale = languageDetector.detect() || DEFAULT_LOCALE;
  const handleError = useCallback(() => {
    console.info('Translations is not full');
  }, []);
  const currentLocaleTwoSymbols = useMemo(() => currentLocale.slice(0, 2), [currentLocale]);
  const {
    data: messages = {}
  } = useQuery({
    queryKey: ['messages', currentLocaleTwoSymbols],
    queryFn: () => getMessages(currentLocaleTwoSymbols as TpLocale),
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
  return <Provider defaultLocale="en" locale={currentLocaleTwoSymbols as TpLocale} messages={messages} onError={handleError} data-sentry-element="Provider" data-sentry-component="IntlProvider" data-sentry-source-file="provider.tsx">
      {children}
    </Provider>;
};
type TpIntlProviderProps = {
  children: ReactNode;
};